<template>
  <h1 class="page-title">
    <slot />
  </h1>
</template>

<script>
export default {
  name: 'PageTitle'
}
</script>

<style lang="sass">
.page-title
  font-size: 40px
  font-weight: 700
  line-height: 48px
  margin-bottom: 50px
  text-align: center
</style>



// WEBPACK FOOTER //
// src/components/ui/PageTitle.vue